import src from "IMAGE";
export default { src, width: 467, height: 163, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAIElEQVR42oXMwQkAAAzCwOy/c7E6gHjfQDhTkYYG1uEBeLFfgZS31dcAAAAASUVORK5CYII="};
